import {
  SET_SURFACE, SET_CURRENT_SKU, SET_COUNTERTOP_SURFACES,
  SET_SELECTED_COLOR_SORT,
  SET_SELECTED_COLOR,
  TOGGLE_MOBILE_SIDE_DRAWER,
  SET_PRODUCT_AVAILABILITY,
  GET_COUNTERTOP_SURFACES_PENDING,
  GET_COUNTERTOP_SURFACES_FULFILLED,
  GET_COUNTERTOP_SURFACES_FAILED,
  SET_SELECTED_COLOR_FILTERS,
  SET_CURRENT_SURFACE,
  SET_LAMINATE_POST_FORM_FEATURE_GATE
} from '../actions/actionTypes';

import { SortColorsBy } from '../common/constants';

const initialState = {
  selectedSku: null,
  currentSurface: {
    surfureCode: null,
    skus: [],
  },
  surfaces: [],
  allSurfaceColors: [],
  selectedColorSort: SortColorsBy.TopSellers,
  selectedColor: {},
  selectedColorFilters: [],
  mobileSideDrawerOpen: false,
  isProductAvailable: null,
  availableSkus: null,
  selectedThickness: null,
  currentSurfaceCodes: null,
  laminatePostFormFeatureGate: false,
};

export default (state = initialState, action) => {
  switch (action.type) {
  case SET_COUNTERTOP_SURFACES:
    return {
      ...state,
      surfaces: action.payload.surfaceCodes,
      allSurfaceColors: action.payload.allSurfaceColors,
    };
  case SET_SURFACE:
    return {
      ...state,
      currentSurface: action.surface,
      availableSkus: action.availableSkus,
      currentSurfaceCodes: action.currentSurfaceCodes,
    };
  case SET_CURRENT_SURFACE:
    return {
      ...state,
      currentSurface: action.surface,
    };
  case SET_CURRENT_SKU:
    return {
      ...state,
      selectedSku: action.sku,
      selectedThickness: action.height,
    };
  case SET_SELECTED_COLOR_SORT:
    return {
      ...state,
      selectedColorSort: action.selectedColorSort,
    };
  case SET_SELECTED_COLOR:
    return {
      ...state,
      selectedColor: action.selectedColor,
    };
  case TOGGLE_MOBILE_SIDE_DRAWER:
    return {
      ...state,
      mobileSideDrawerOpen: !state.mobileSideDrawerOpen,
    };
  case SET_PRODUCT_AVAILABILITY:
    return {
      ...state,
      isProductAvailable: action.availability,
    };
  case GET_COUNTERTOP_SURFACES_PENDING:
    return {
      ...state,
      getCoutnertopSurfacesStatus: 'PENDING',
    };
  case GET_COUNTERTOP_SURFACES_FULFILLED:
    return {
      ...state,
      getCoutnertopSurfacesStatus: 'FULFILLED',
    };
  case GET_COUNTERTOP_SURFACES_FAILED:
    return {
      ...state,
      getCoutnertopSurfacesStatus: 'FAILED',
    };
  case SET_SELECTED_COLOR_FILTERS:
    return {
      ...state,
      selectedColorFilters: action.selectedColorFilters,
    };
  case SET_LAMINATE_POST_FORM_FEATURE_GATE:
    return {
      ...state,
      laminatePostFormFeatureGate: action.laminatePostFormFeatureGate,
    };
  default:
    return state;
  }
};
